export const SECTORS = {
  SET_SECTORS: 'SET_SECTORS',
  SET_FILES_COUNT: 'SET_FILES_COUNT'
}
